import React from 'react'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'

const Main = styled.main`
  display: flex;
  justify-content: center;
  align-items: center;
`
// location is given by <Redirect />
// https://reactrouter.com/web/api/Redirect/to-object
const PageNotFound = () => {
  const location = useLocation()
  return (
    <Main>
      <p>{location.state ? location.state.message : 'Page not found.'}</p>
    </Main>
  )
}

export default PageNotFound
